// inject any non-blocking stylesheets:
$(window).on('load', function() {
  $('head').append( $('#nonblocking').text() );
});

// Prevent disabled button clicks
$('a.disabled').on('click', function(e) {
  e.preventDefault();
});

function resizeContentBlocks() {
  if ( $(window).width() > 740 ) {
    var buttonSpacing = 80;
    // Get an array of all element heights
    var contentBlockHeights = $('.content-block-inner').map(function() {
      if ( $(this).hasClass('height-normalized') ) {
        $(this).height('auto');
      }
      return $(this).height() + buttonSpacing;
    }).get();

    // Math.max takes a variable number of arguments
    // `apply` is equivalent to passing each height as an argument
    var maxHeight = Math.max.apply(null, contentBlockHeights);

    // Set each height to the max height
    $('.content-block-inner').height(maxHeight).addClass('height-normalized');
  } else {
    $('.content-block-inner').height('auto');
  }

}; // resizeContentBlocks()

// Equalize content block heights
if ( $('.content-block-container').length ) {
  resizeContentBlocks();

  $(window).resize(function() {
    resizeContentBlocks();
  });

  setTimeout(resizeContentBlocks, 200);
}
